import { Navigate } from "react-router-dom";

export default function AreasVerdes() {
  return <Navigate to="/ambiental" replace />;
}